import { Injectable } from '@angular/core';
import * as configdata from "../../assets/config/config.json"

@Injectable()
export class AppConfigService {
    static settings: IAppConfig;

    xml: any;
    xmlrespose: any;
    dataarray: any;

    constructor() {
        AppConfigService.settings = <IAppConfig>((configdata as any).default || configdata);
    }

    load() {
        return AppConfigService.settings = <IAppConfig>((configdata as any).default || configdata);
    }
}
export interface IAppConfig {
  UserLogin: any,
  WebApiURL: any,
  WebApiDotComURL: any,
  RouteNameSuggest: any,
}
